import { IRiskMitigationAction } from "./RiskMitigationAction";
import { IProgressUpdateWithDeliveryDates, ProgressUpdateWithDeliveryDates } from "./ProgressUpdate";

export interface IRiskMitigationActionUpdate extends IProgressUpdateWithDeliveryDates {
    RiskMitigationActionID: number | null;
    SignOffID: number | null;
    RiskMitigationAction?: IRiskMitigationAction;
}

export class RiskMitigationActionUpdate extends ProgressUpdateWithDeliveryDates implements IRiskMitigationActionUpdate {
    public RiskMitigationActionID: number | null = null;
    public SignOffID = null;

    constructor(riskMitigationActionId: number, period?: Date) {
        super(period);
        this.RiskMitigationActionID = riskMitigationActionId;
    }
}